import { render, staticRenderFns } from "./PageVerifyEmail.vue?vue&type=template&id=1ba8d748&scoped=true&"
import script from "./PageVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./PageVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./PageVerifyEmail.vue?vue&type=style&index=0&id=1ba8d748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8d748",
  null
  
)

export default component.exports